import { Component, HostListener, OnInit } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { GlobalService } from "@core/services/global.services";
import { USER_PERMISSIONS } from "@core/entities";
import { TranslateService } from "@ngx-translate/core";
import { firstValueFrom } from "rxjs";
import { HomeCardsConfig } from "@core/entities";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  homeKustomer = false;
  isLoading = true;
  title = "Home";
  subTitle =
    localStorage.getItem("validUser") === "false"
      ? "No te encuentras activo en la plataforma, por favor comunícate con el área comercial de Rappi Turbo para gestionar tu acceso."
      : "En el menú lateral izquierdo puedes encontrar lo que estás buscando";
  cards: Array<{
    route: string;
    title: string;
    description: string;
    navigateButton: string;
    urlExternal: string;
  }> = [];
  displayExternal = false;
  iframeSrc: SafeResourceUrl;
  breadcrumbTitle = "Home";

  @HostListener("window:message", ["$event"])
  onMessage(event) {
    if (event.data.type === "FINISH_LOAD_USER_DATA") {
      this.loadHome();
    }
  }

  constructor(
    private readonly sanitizer: DomSanitizer,
    private readonly globalService: GlobalService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    const token = JSON.parse(localStorage.getItem("app_storage"))?.tokenClaims;
    if (token) {
      this.loadHome();
    }
  }

  loadHome() {
    this.isLoading = true;
    const permissionHomeKustomer = this.validatePermission(
      USER_PERMISSIONS.HOME_KUSTOMER
    );
    if (permissionHomeKustomer) {
      this.globalService
        .getParameterValue("TURBO-PORTALS-MANAGER-MS_HOME_KUSTOMER")
        .subscribe(
          (response) => {
            if (response) {
              this.loadCardsFromDevConfig();
              this.homeKustomer = true;
            }
            this.isLoading = false;
          },
          () => {
            this.isLoading = false;
          }
        );
    } else {
      this.isLoading = false;
    }
  }

  async loadCardsFromDevConfig() {
    const cards: HomeCardsConfig = await firstValueFrom(
      this.translateService.get("HOME_KUSTOMER.CARDS")
    );
    this.cards = Object.values(cards);
  }

  handleNavigate(urlExternal: string, cardTitle: string): void {
    if (urlExternal) {
      this.displayExternal = true;
      this.iframeSrc =
        this.sanitizer.bypassSecurityTrustResourceUrl(urlExternal);
    }

    this.breadcrumbTitle = cardTitle;
  }

  handleBackCards() {
    this.displayExternal = false;
    this.iframeSrc = null;
  }

  validatePermission(permissionAllowed: string) {
    const appStorage = JSON.parse(localStorage.getItem("app_storage")) || null;
    return appStorage?.dataUser?.permissions?.includes(permissionAllowed);
  }
}
